<template>
    <div>{{sn}}</div>
</template>

<script>
    export default {
        components:{},
        props: ['sn'],
        data(){
            return {}
        },
        created() {
            this.$toast.success('正在识别 ...')
            this.findDevice()
        },
        mounted(){},
        methods: {
            findDevice() {
                this.$http.tokiot.device.list({sn: this.sn})
                    .then(ret => {
                        if (ret) {
                            const device = ret.rows.find(device => device.sn = this.sn)
                            if (device) {
                                this.showDevice(device)
                            } else {
                                this.installDevice(this.sn)
                            }
                        }
                    })
            },
            showDevice(device) {
                this.$router.replace(`/device/${device.id}`)
            },
            installDevice(sn) {
                this.$router.replace(`/device/install/${sn}`)
            },
        },
        watch:{}
    }
</script>

<style scoped>

</style>